export const isAuthenticated = (state) => !!state.token
export const pseudo = (state) => state.pseudo